import {
    DASHBOARD_REVENUE_DETAILS_LOADING,
    DASHBOARD_REVENUE_DETAILS_SUCCESS,
} from '../actions/dashboardActions';

const initialState = {
    amazon: {
        revenueData: null,
        isLoading: true
    },
    shopify: {
        revenueData: null,
        isLoading: true
    },
    wholesale: {
        revenueData: null,
        isLoading: true
    }
};

const dashboardReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case DASHBOARD_REVENUE_DETAILS_SUCCESS:
            return { ...state, [action.vendor]: { revenueData: action.data, isLoading: false } };
        case DASHBOARD_REVENUE_DETAILS_LOADING:
            return { ...state, [action.vendor]: { ...state[action.vendor], isLoading: action.isLoading } };
        default:
            return state;
    }
};

export default dashboardReducer;
